/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getGoogleSuggestedAddress = (state) => state?.mfeCheckout?.search?.googleAddressSearch?.selectedAddress;

export default {};
